import qs from 'qs';

// 几个页面公用的逻辑
export default {
    created() {
        this.initPageType();
    },

    methods: {
        /** 获得通用基础信息。注意，这个是异步请求的，所以只能在对应的组件中await调用，否则无法阻塞后续流程 */
        async initBaseInfo() {
            // 从全局变量中获得主号等信息
            const { envConfig } = window.QD_ADMIN_COMMON || {};
            const { isPrivate } = envConfig || {};
            window.isPrivate = isPrivate;

            // wpa2的wpa预览组件要使用到kfuin。
            window.data = window.data || {};
            window.data.info = window.data.info || {};
            window.data.data = window.data.data || {};

            await new Promise((resolve) => {
                // QD_ADMIN_COMMON 要在 dataReady 之后才能获取到。
                window.QD_ADMIN_COMMON.on('dataReady', (data) => {
                    const { profile, set, } = data || {};
                    const { kfuin } = profile || {};
                    window.data.info.kfuin = kfuin;
                    window.data.set = set || {}; // 新版导航没有set，兜底。

                    resolve(true);
                });
            });

            // 获取公众号列表
            let accountList = await this.$ajax.gatewayGet(`/mp/accountInfo/getAccountInfo?count=9999`);
            // 之前php接口不知道什么原因，把 accountId 换成了 id 的值。 去框架机后，由前端自行转换一下，把数据和之前的对齐。
            accountList = (accountList || []).map((item) => {
                if (item.id) {
                    // 注意，部分数据没有id，还是使用accountID。
                    item.orginalAccountID = item.accountID;
                    item.accountID = String(item.id);
                } else {
                    // 强制转换为字符串
                    item.accountID = String(item.accountID);
                }

                if (typeof (item.icon) === 'undefined') {
                    item.icon = item.faceUrl || '';
                }
                if (typeof (item.name) === 'undefined') {
                    item.name = item.accountName || '';
                }

                return item;
            });
            window.data.data.accountList = accountList;

            // 路径下没有accountID，则使用第一个公众号的accountID
            const params = qs.parse(window.location.search.split('?')[1]) || {};
            window.data.data.accountID = String(params.accountID || (accountList[0] && accountList[0].accountID) || '');
            this.accountID = window.data.data.accountID;

            this.accountListLength = accountList.length;
        },

        /** 获取pageType */
        initPageType() {
            window.data = window.data || {};
            window.data.data = window.data.data || {};

            // 根据server查看php的逻辑进行处理：关键字/新消息/关注tab时是1；菜单tab是0
            let pageType = window.data.data.pageType;
            if (typeof (pageType) === 'undefined') {
                pageType = 1;
                if (location.pathname.indexOf('/mp/menu') === 0) {
                    pageType = 0;
                }
                console.log('pageType', pageType);
                window.data.data.pageType = pageType;
            }
        },
    },
};
